import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "And we're done",
  "description": "",
  "published": "2007-06-23T00:00:00.000Z",
  "redirect_from": ["/blog/and-were-done/swizec/184"],
  "categories": "life, linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Well yesterday was the last day of A-levels making it the final day of having to even remotely worry about something high school related. Sure I still have to wait for the results, but that doesn't trouble me much because all I need to be accepted into my chosen university is a pass. My gut tells me I'll get heaps more than just a pass, we'll see.`}</p>
    <p>{`In the meantime `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=XngQJzAmVm8"
      }}>{`here`}</a>{` are `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=4luRhIxvAX8"
      }}>{`some`}</a>{` `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=n3g5MKeqBwI"
      }}>{`high`}</a>{` `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=66qZq_8eP20"
      }}>{`speed`}</a>{` `}<a parentName="p" {...{
        "href": "http://uk.youtube.com/watch?v=WWjRzy-pTsE"
      }}>{`water`}</a>{` balloon videos. Quite amazingly awesome, wish my eyes could do high speed.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      